import { Card, Col, Form, Input, Row } from 'antd';

export default function ClientInfoSection({ companyData: _companyData, qt }) {
  return (
    <Card
      title={qt('questionnaire.clientInformation')}
      className="mb-5"
      style={{ marginBottom: '20px' }}
    >
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label={qt('questionnaire.clientName')}
            name="name"
            style={{ marginBottom: '10px' }}
          >
            <Input disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={qt('questionnaire.location')}
            name={['generalData', 'city']}
            style={{ marginBottom: '10px' }}
          >
            <Input disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={qt('questionnaire.streetAndNumber')}
            name={['generalData', 'address']}
            style={{ marginBottom: '10px' }}
          >
            <Input disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={qt('questionnaire.registrationNumber')}
            name={['generalData', 'code']}
            style={{ marginBottom: '10px' }}
          >
            <Input disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label={qt('questionnaire.tin')}
            name={['generalData', 'pib']}
            style={{ marginBottom: '10px' }}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}
